import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { RuntimeEnvironments } from '@environments/runtimeEnviroments.enum';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    constructor() {}

    getEnvironment(): RuntimeEnvironments {
        return environment.env;
    }
}
